import React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
  useTheme,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';

export default function TrnVerifyResultsModal({ open, onClose, result, trn, labels, onSelectName }) {
  const theme = useTheme();

  if (!open || !result) return null;

  const title =
    result.kind === 'match'
      ? labels.matchTitle
      : result.kind === 'mismatch'
        ? labels.mismatchTitle
        : labels.lookupTitle;

  const description =
    result.kind === 'match'
      ? labels.matchDescription.replace('{trn}', trn).replace('{name}', result.matchName)
      : result.kind === 'mismatch'
        ? labels.mismatchDescription.replace('{trn}', trn).replace('{name}', result.enteredName)
        : labels.lookupDescription.replace('{trn}', trn);

  const names = result.kind === 'match' ? [result.matchName] : result.names;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ pr: 6 }}>
        <Stack direction="row" spacing={1} alignItems="center">
          {result.kind === 'match' && <CheckCircleOutlineIcon color="success" fontSize="small" />}
          {result.kind === 'mismatch' && <HighlightOffIcon color="error" fontSize="small" />}
          <Typography variant="h6">{title}</Typography>
        </Stack>
        <IconButton onClick={onClose} sx={{ position: 'absolute', right: 12, top: 12 }} aria-label="Close">
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {description}
        </Typography>
        <Stack spacing={1}>
          {names.map((name) => (
            <Box
              key={name}
              component="button"
              type="button"
              disabled={result.kind === 'match'}
              onClick={() => {
                if (result.kind === 'match') return;
                onSelectName(name);
              }}
              sx={{
                textAlign: 'left',
                width: '100%',
                border: '1px solid',
                borderColor:
                  result.kind === 'match'
                    ? theme.palette.success.light
                    : result.kind === 'mismatch'
                      ? theme.palette.error.light
                      : theme.palette.divider,
                borderRadius: 1,
                p: 1.5,
                bgcolor: theme.palette.background.paper,
                cursor: result.kind === 'match' ? 'default' : 'pointer',
                '&:hover':
                  result.kind === 'match'
                    ? undefined
                    : {
                        bgcolor: theme.palette.action.hover,
                      },
              }}
            >
              <Typography variant="body2" fontWeight={600}>
                {name}
              </Typography>
            </Box>
          ))}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined" size="small">
          {labels.close}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
